import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Service from "../../components/Service";
import styles from "./index.modules.less";
import Tab from "../../components/Tabs/";
import Cardlist from "../../components/CardList";
import Table from "../../components/Table";
import NoAccess from "../../components/NoAccess";
import Empty from "../../components/Empty";
import AddModal from "../../components/AddModal";
import ConfirmModal from "../../components/ConfirmModal";
import { createSoft } from "../../service/home";
import { message } from "../../components/Message";
import errorCode from "../../utils/errCode"

const SoftList = ({ type, data, loading, tabkey, setOpen }) => {
  console.log("loading is", loading)
  const list = data?.list ?? [];
  if (!loading && list.length === 0) {
    return <Empty setOpen={setOpen}></Empty>;
  }
  if (type == "table") {
    return <Table tabkey={tabkey} data={data}></Table>;
  }
  return <Cardlist data={data}></Cardlist>;
};

const Home = () => {
  const [showListType, setShowType] = useState("table");
  const { user, soft, permission } = useSelector((state) => state);
  const dispatch = useDispatch();
  const modelRef = useRef(null);
  const [formValues, setFormValues] = useState();
  const [open, setOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [tabkey, setTabkey] = useState(911);
  const onCreate = (values) => {
    console.log("Received values of form: ", values);
    createSoft({ ...values }).then((res) => {
      dispatch.soft.setSoftListAsync();
      message.show({
        type: 'success',
        content: '软件创建成功'
      })
    }).catch((e) => {
      console.log("无错误", e)
      message.show({
        type: 'error',
        content: errorCode[e.errno] || e.errmsg,
        closeTime: 2000
      })
    })
    setFormValues(values);
    setOpen(false);
  };

  const tabs = [
    {
      id: 911,
      name: "我的全部软件",
      component: (
        <SoftList
          loading={soft.loading}
          data={soft.softList}
          type={showListType}
          tabkey={tabkey}
          setOpen={setOpen}
        ></SoftList>
      ),
    },
    {
      id: 4,
      name: "已上架",
      component: (
        <SoftList
          loading={soft.loading}
          data={soft.softList}
          type={showListType}
          tabkey={tabkey}
          setOpen={setOpen}
        ></SoftList>
      ),
    },
    {
      id: 2,
      name: "申请中",
      component: (
        <SoftList
          loading={soft.loading}
          data={soft.softList}
          type={showListType}
          tabkey={tabkey}
          setOpen={setOpen}
        ></SoftList>
      ),
    },
  ];

  console.log("home soft is", soft);

  useEffect(() => {
    if (user?.is_mfr == false) {
      modelRef?.current?.show();
    }
    if (user?.qid) {
      dispatch.soft.setSoftListAsync()
    }
    // dispatch.soft.setSoftListAsync();
  }, [user]);

  const onChangeTabHandle = (key) => {
    console.log("tabkey", key);
    setTabkey(key)
  };

  if (!user?.is_mfr && !permission?.isUnionUser) {
    return (
      <NoAccess ref={modelRef}></NoAccess>
    )
  }

  return (
    <div className={styles.homeWrapper}>
      <Service setOpen={setOpen} identityType={permission?.identityType} permissionCodes={permission?.permissionCodes}></Service>
      <Tab
        defaultActiveKey={911}
        onChangeTab={(key) => onChangeTabHandle(key)}
        onChangeShowType={setShowType}
        showListType={showListType}
        items={tabs.map((item, i) => {
          return {
            label: item.name,
            key: item.id,
            children: item.component,
          };
        })}
      />
      <NoAccess ref={modelRef}></NoAccess>
      <AddModal
        open={open}
        onCreate={onCreate}
        onCancel={() => setOpen(false)}
        initialValues={{ modifier: "public" }}
      />
      <div className={styles.footer}>
        <span> Copyright © 2005 - <span class="current-year">2026</span> 360.CN All Rights Reserved 360互联网安全中心隐私权政策 京ICP证080047号 </span>        
        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=11010502062738" rel="noreferrer" target="_blank" ><img src="//p4.ssl.qhmsg.com/t01d8eda6e551cf2615.png" alt="" />京公网安备11010502062738号</a>
      </div>

    </div>
  );
};

export default Home;
